import React from "react";
import useAttachmentBlob from "./useAttachmentBlob";

/** An auth-protected image: loaded as a blob URL, revoked on unmount. */
const AuthImage = ({ url, alt, className = "", style }) => {
  const { src, failed } = useAttachmentBlob(url);
  if (failed) {
    return (
      <div className={className} style={{ display: "grid", placeItems: "center", fontSize: 11, color: "var(--faint)", ...style }}>
        Failed to load
      </div>
    );
  }
  if (!src) return <div className={className} style={{ background: "var(--raise)", ...style }} />;
  return <img src={src} alt={alt} className={className} style={style} />;
};

export default AuthImage;
